import { render, staticRenderFns } from "./HubNotFound.vue?vue&type=template&id=13267de6"
import script from "./HubNotFound.vue?vue&type=script&lang=js"
export * from "./HubNotFound.vue?vue&type=script&lang=js"
import style0 from "./HubNotFound.vue?vue&type=style&index=0&id=13267de6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports